<template>
	<div>
		<ChangeController :visible='dataChanged' @close='show=false' @revert='revert' @save='save' />
		
		<v-card>
			<v-card-text>
				<section>
					<h2 class='mb-4'>AIM AND PURPOSE FOR THE PRIMAR S-100 CAPACITY BUILDING FUND</h2>
					<TextEditor v-model='data.section1' @show-change='dataChanged = true'/>
				</section>
				<section>
					<h2 class='mb-4'>CRITERIA FOR THE USE OF THE PRIMAR S-100 CAPACITY BUILDING FUND</h2>
					<TextEditor v-model='data.section2' @show-change='dataChanged = true'/>
				</section>
				<section>
					<h2 class='mb-4'>APPROVED S-100 CAPACITY BUILDING ACTIVITIES</h2>
					<TextEditor v-model='data.section3' @show-change='dataChanged = true'/>
				</section>
			
				<section class="mb-10">
					<h2 class="mb-4">File Attachments</h2>
					<Collection
						cols='auto'
						:collection="data.files"
						@change="dataChanged = true"
						dialogWidth="600"
						:form="$options.FileForm"
						title="File Attachment"
						breakpoints="xs12 sm3 md3 lg3 xl2"
						isFileUpload
					>
						<FileItem slot-scope="{ item }" v-bind="item" />
					</Collection>
				</section>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import TextEditor from '@/components/admin/TextEditor'

import Collection from '@/components/admin/ItemCollection'
import FileItem from '@/components/n-collections/n-items/FileItem'

import FileForm from '@/components/dialogs/forms/FileForm'

import DataMixin from '@/mixins/DataMixin'

export default {
	name: 'AdminBuildFund',
	mixins: [DataMixin],
	FileForm,
	components: {
		TextEditor,
		Collection,
		FileItem
	},
}
</script>

<style lang="scss" scoped>
</style>